import { Controller } from "stimulus"
import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = [ "modal","form" ];
  static classes = ["open","hidden"];
  modal() {
    this.modalTarget.classList.toggle(this.openClass);
  }
  cancel() {
    const url = this.formTarget.getAttribute("action");
    const confirm = document.getElementById("cancel_confirm");
    const success = document.getElementById("canceled");
    const bg = document.getElementById("modal_background");
    const canceled_bg = document.getElementById("modal_background_canceled");
    console.log(url);
    Rails.ajax({
      url: url,
      type: "POST",
      dataType: 'json',
      success: (response)=> {
        if(response.status == "success"){
          confirm.classList.add(this.hiddenClass);
          bg.classList.add(this.hiddenClass);
          success.classList.remove(this.hiddenClass);
          canceled_bg.classList.remove(this.hiddenClass);
        }
      }
    });
  }
  cancelClose(){
    window.location.reload();
  }
}
